import * as React from 'react';

import { DropdownButton, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';

import { TFunction } from 'i18next';
import { deleteFacilityFromContact } from '../../actions/manageFacilityActions';
import { IfacilityContact } from '../../models';
import { RowInfo } from 'react-table';
interface RowInfoEdited extends RowInfo {
    original: IfacilityContact;
}
interface Iprops {
    t: TFunction;
    colorButton: string;
    deleteFacilityFromContact: typeof deleteFacilityFromContact;
    handleSelectContactEdit: (rowInfo: RowInfoEdited) => void;
    addContactLead?: (contact: IfacilityContact) => void;
    rowInfo: RowInfoEdited;
    facilityID: string;
}

export const ContactActionButton = (props: Iprops) => {
    const { t, rowInfo, facilityID } = props;
    const sapSource = rowInfo.original.source === 1;
    const onSelect = (eventKey: any) => {
        switch (eventKey) {
            case 1:
                props.deleteFacilityFromContact(
                    rowInfo.original.id,
                    facilityID,
                    t
                );
                break;
            case 2:
                props.handleSelectContactEdit(rowInfo);
                break;
            case 3:
                if (props.addContactLead !== undefined) {
                    props.addContactLead(rowInfo.original);
                }
                break;
            default:
                break;
        }
    };
    return (
        // keep menu clicks from also opening the row preview
        <span onClick={e => e.stopPropagation()}>
            <DropdownButton
                pullRight
                noCaret
                bsStyle="link"
                bsSize="small"
                className="contact-action-ellipsis"
                title={<FontAwesomeIcon icon={faEllipsisH} />}
                id={`contact-action-${rowInfo.original.id}`}
                onSelect={onSelect}
            >
                {props.addContactLead !== undefined && (
                    <MenuItem eventKey={3}>
                        {t('facilityContactForm.select')}
                    </MenuItem>
                )}
                <MenuItem eventKey={2}>
                    {t('facilityContactForm.edit')}
                </MenuItem>
                <MenuItem eventKey={1} disabled={sapSource}>
                    {t('facilityContactForm.delete')}
                </MenuItem>
            </DropdownButton>
        </span>
    );
};
